<template>
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <md-button class="md-icon-button" @click="showNavigation = !showNavigation">
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-title">SiftAI Data Labeler</span>
        <!--md-progress-bar v-if="$root.loading>0" md-mode="indeterminate" style="width:100%;position:absolute;left:0px;top:0px;height:5px;opacity:.95;filter:grayscale(1);"></md-progress-bar-->
      </md-app-toolbar>
      <md-app-drawer :md-active.sync="showNavigation" md-swipeable>
        <md-toolbar class="md-transparent" md-elevation="0">Navigation</md-toolbar>

        <md-list @click="showNavigation=false">
          <md-list-item v-if="isAuthenticated" to="/Jobs">
            <md-icon>move_to_inbox</md-icon>
            <span class="md-list-item-text">Jobs Available</span>
          </md-list-item>
          <md-list-item v-if="!isAuthenticated" v-on:click="login()">
            <md-icon>logout</md-icon>
            <span class="md-list-item-text">Login</span>
          </md-list-item>
          <md-list-item v-if="isAuthenticated" v-on:click="password()">
            <md-icon>vpn_key</md-icon>
            <span class="md-list-item-text">Change Password</span>
          </md-list-item>
          <md-list-item v-if="isAuthenticated" v-on:click="logout()">
            <md-icon>logout</md-icon>
            <span class="md-list-item-text">Logout</span>
          </md-list-item>
          <md-list-item v-if="profile">
            <md-avatar>
              <img :src="profile.picture" alt="Avatar">
            </md-avatar>
            <div style="width:inherit;">
              <h2 style="margin-bottom:0px;">{{ my_name(profile) }}</h2>
              <p style="margin-top:0px;">{{ profile.email }}</p>
            </div>
          </md-list-item>
        </md-list>
      </md-app-drawer>

      <md-app-content>

        <router-view/>
        <md-progress-spinner  v-if="$root.loading" :md-diameter="150" :md-stroke="10" md-mode="indeterminate" class="pageloading"></md-progress-spinner>
      </md-app-content>
    </md-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    showNavigation: false,
    isAuthenticated: false,
    profile: (this.$auth ? this.$auth.profile : false)
  }),
  methods: {
    login: function () {
      this.$auth.login()
    },
    logout: function () {
      this.$auth.logOut()
    },
    password: function () {
      this.$auth.password()
    },
    handleLoginEvent (data) {
      this.isAuthenticated = data.loggedIn
      this.profile = data.profile
    },
    capital_letter (str) {
      str = str.split(' ')
      for (var i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1)
      }
      return str.join(' ')
    },
    my_name (profile) {
      if (profile.name === profile.email) {
        return this.capital_letter(profile.nickname)
      }
      return this.capital_letter(profile.name)
    }
  }
}
</script>

<style lang="scss" scoped>
  .md-app {
    min-height: 100%;
  }

  .md-app-container {
    overflow-x:hidden;
  }

  .pageloading {
    position: absolute;
    left: calc(50% - 75px);
    top: 25%;
    z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue